import React from "react";
import { connect } from "react-redux";
import { UAParser } from "ua-parser-js";

import { Text } from "../../atoms/Text/Text";
import { isServer } from "../../../utils";
import { Game } from "../../models/Game";
import { widgetSizeService } from "./FreshdeskService";
import styles from "./Freshdesk.css";

const ContactUsButton = (props: any) => (
  <button className={styles.contactUsButton} {...props} />
);

class FreshdeskDumb extends React.PureComponent<{ size: string; game?: Game }> {
  freshdeskData: any = {};

  componentDidMount() {
    if (!isServer) {
      this.init();
      this.getSystemInfo();
      this.fillTheData();
      this.hideFormFields();
    }
  }

  showContactForm = () => {
    const { game } = this.props;

    (window as any).FreshworksWidget("prefill", "ticketForm", {
      subject: game ? game.seo_GameName : "",
      custom_fields: {
        cf_game_tag: this.props.game ? this.props.game.slug : "",
        cf_full_url: window.location.href,
        cf_screen_size: widgetSizeService.getScreenSize(),
        cf_window_size: widgetSizeService.getWindowSize(),
        cf_game_size: widgetSizeService.getGameSize(),
      },
    });

    (window as any).FreshworksWidget("open");
    const checkFeedbackWidget = setInterval(() => {
      clearInterval(checkFeedbackWidget);
      this.hideLauncherBtn();
    }, 200);
  };

  render() {
    return (
      <ContactUsButton onClick={this.showContactForm}>
        <style
          dangerouslySetInnerHTML={{ __html: `#launcher {display: none;}` }}
        />
        <Text size={this.props.size} className={styles.nobr} bold={true}>
          Contact Arkadium Support.
        </Text>
      </ContactUsButton>
    );
  }

  init() {
    const w = window as any;
    if (!w.FreshworksWidget) {
      // hide default freshdesk button
      const css = `
                #launcher-frame
                {
                    display:none;
                }
                .frame-right {
                    bottom:10px !important;
                }
            `;
      const style = document.createElement("style");
      style.type = "text/css";
      document.head.appendChild(style);
      style.appendChild(document.createTextNode(css));

      // load freshdesk widget scripts (snippet 1)
      const script1 = document.createElement("script");
      script1.text = `
                window.fwSettings = {"widget_id": 44000000137};
                !function () {
                    if ("function" != typeof window.FreshworksWidget) {
                        var n = function () {
                            n.q.push(arguments)
                        };
                        n.q = [], window.FreshworksWidget = n
                    }
                }();
            `;
      document.head.appendChild(script1);

      // load freshdesk widget scripts (snippet 2)
      const script2 = document.createElement("script");
      script2.src = "https://widget.freshworks.com/widgets/44000000137.js";
      script2.async = true;
      script2.defer = true;
      document.head.appendChild(script2);
    }
  }

  private fillTheData() {
    (window as any).FreshworksWidget("prefill", "ticketForm", {
      custom_fields: {
        cf_os: this.freshdeskData.os + " " + this.freshdeskData.osVersion,
        cf_browser:
          this.freshdeskData.browser + " " + this.freshdeskData.browserVersion,
        cf_device_type: this.freshdeskData.deviceType,
        cf_arena_url: this.freshdeskData.hostName,
        cf_is_mobile: this.freshdeskData.mobile,
        cf_is_adblock_active: this.freshdeskData.isAdBlockerActive,
      },
    });
  }

  private hideLauncherBtn() {
    const iframe = window.document.getElementById("launcher-frame");
    if (iframe) {
      iframe.style.display = "none";
    }
  }

  private hideFormFields() {
    (window as any).FreshworksWidget("hide", "ticketForm", [
      "custom_fields.cf_os",
      "custom_fields.cf_browser",
      "custom_fields.cf_game_tag",
      "custom_fields.cf_arena_url",
      "custom_fields.cf_full_url",
      "custom_fields.cf_is_mobile",
      "custom_fields.cf_device_type",
      "custom_fields.cf_is_adblock_active",
      "custom_fields.cf_screen_size",
      "custom_fields.cf_window_size",
      "custom_fields.cf_game_size",
      "custom_fields.cf_user_email",
    ]);
  }

  private getSystemInfo() {
    const parser = new UAParser(); // use 3rd party library to parse UA
    // https://github.com/faisalman/ua-parser-js

    // browser
    const browserInfo = parser.getBrowser();
    let browserVersion = browserInfo.version;

    try {
      const v = browserInfo.version;
      browserVersion = v.substring(0, v.indexOf("."));
    } catch (e) {}

    // is mobile version
    const deviceInfo = parser.getDevice();
    const mobile = deviceInfo.type === "mobile" || deviceInfo.type === "tablet";
    const deviceType = deviceInfo.type || "pc";

    // operating system
    const osInfo = parser.getOS();

    // getting game name
    let gameName = "";
    if ((window as any).location.pathname.indexOf("/games/") !== -1) {
      const parts = (window as any).location.pathname.split("/games/");
      gameName = parts[parts.length - 1].replace("/", "");
    }

    if ((window as any).location.pathname.indexOf("/category/") !== -1) {
      gameName = "Category Page";
    }
    // adding info to the global object
    this.freshdeskData = {
      browser: browserInfo.name,
      browserVersion,
      deviceType,
      mobile,
      os: osInfo.name,
      osVersion: osInfo.version,
      hostName: (window as any).location.host,
    };
  }
}

export const Freshdesk = connect()(FreshdeskDumb);
